export const ACCEPT = '.png,.psd,.jpg,.jpeg,.webp';
const EXT = /\.(png|psd|jpe?g|webp)$/i;
export function isSupportedName(name: string): boolean { return EXT.test(name); }
export function newDocId(): string {
  return typeof crypto !== 'undefined' && 'randomUUID' in crypto ? crypto.randomUUID() : `d${Date.now()}${Math.random().toString(16).slice(2)}`;
}
